export interface PhoneCountry {
  code: string;
  dialCode: string;
  flag: string;
  minNationalLength: number;
  maxNationalLength: number;
}

export const PHONE_COUNTRIES: readonly PhoneCountry[] = [
  { code: 'CN', dialCode: '+86', flag: '🇨🇳', minNationalLength: 11, maxNationalLength: 11 },
  { code: 'HK', dialCode: '+852', flag: '🇭🇰', minNationalLength: 8, maxNationalLength: 8 },
  { code: 'MO', dialCode: '+853', flag: '🇲🇴', minNationalLength: 8, maxNationalLength: 8 },
  { code: 'TW', dialCode: '+886', flag: '🇹🇼', minNationalLength: 9, maxNationalLength: 9 },
  { code: 'JP', dialCode: '+81', flag: '🇯🇵', minNationalLength: 9, maxNationalLength: 10 },
  { code: 'KR', dialCode: '+82', flag: '🇰🇷', minNationalLength: 9, maxNationalLength: 10 },
  { code: 'SG', dialCode: '+65', flag: '🇸🇬', minNationalLength: 8, maxNationalLength: 8 },
  { code: 'US', dialCode: '+1', flag: '🇺🇸', minNationalLength: 10, maxNationalLength: 10 },
  { code: 'CA', dialCode: '+1', flag: '🇨🇦', minNationalLength: 10, maxNationalLength: 10 },
  { code: 'GB', dialCode: '+44', flag: '🇬🇧', minNationalLength: 10, maxNationalLength: 10 },
  { code: 'AU', dialCode: '+61', flag: '🇦🇺', minNationalLength: 9, maxNationalLength: 9 },
  { code: 'NZ', dialCode: '+64', flag: '🇳🇿', minNationalLength: 8, maxNationalLength: 10 },
] as const;

export function normalizeNationalNumber(value: string, country: PhoneCountry): string {
  const digits = value.replace(/\D/g, '');
  const dialDigits = country.dialCode.slice(1);
  const withoutDialCode = digits.startsWith(dialDigits) && digits.length > country.maxNationalLength
    ? digits.slice(dialDigits.length)
    : digits;
  return withoutDialCode.replace(/^0+/, '').slice(0, country.maxNationalLength);
}

export function isNationalNumberValid(value: string, country: PhoneCountry): boolean {
  return value.length >= country.minNationalLength && value.length <= country.maxNationalLength;
}

export function toE164Phone(value: string, country: PhoneCountry): string {
  return `${country.dialCode}${normalizeNationalNumber(value, country)}`;
}
